import {Field} from './field';

class Line extends Field {
  constructor(field) {
    super(field);

    this.displaySelectType = 'LINE';
    this.displayType = 110;
    this.invalid = false;
  }

  setValue() {
  }

  initValue() {
  }

  clearValue() {

  }
}

export {Line};
